import { render, staticRenderFns } from "./VideoNewClip.vue?vue&type=template&id=47e431f3&scoped=true"
import script from "./VideoNewClip.vue?vue&type=script&lang=js"
export * from "./VideoNewClip.vue?vue&type=script&lang=js"
import style0 from "./VideoNewClip.vue?vue&type=style&index=0&id=47e431f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e431f3",
  null
  
)

export default component.exports